<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:17:17
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-04-02 18:12:20
-->

<template>
  <div class="SchoolProcurementRank">
    <!-- <div class="tab">第{{ current + 1 }}页</div> -->
    <div class="title">
      <span>校园餐学校采购排行</span>
    </div>
    <swiper ref="Swiper" :options="swiperOption" class="swiper">
      <swiper-slide v-for="(data, i) in dataArray" :key="i">
        <vue-seamless-scroll
          v-if="current == i"
          :data="data"
          :class-option="getScrollOption(data.length)"
          class="progress-list"
          @ScrollEnd="handleScrollEnd"
        >
          <div
            v-for="(item, index) in data"
            :key="index"
            :class="['progress-item', 'item' + (pageSize * current + index + 1)]"
            :style="{ animationDelay: `${index * 0.05}s` }"
          >
            <div class="index">
              {{ pageSize * current + index + 1 }}
            </div>
            <img src="@/img/agriculture/arrow.png" alt="" />
            <div class="name">{{ item.gmCustomerName }}({{ item.purchaseAmount }}万元)</div>
          </div>
        </vue-seamless-scroll>
      </swiper-slide>
    </swiper>
    <!-- <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div> -->
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'swiper/dist/js/swiper.esm.bundle.js'
import { customerPurchaseRank } from '@/api/dashboard'
import to from 'await-to'
const _ = require('lodash')
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        autoplay: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        onSlideChangeEnd: swiper => {
          this.current = swiper.activeIndex
        },
      },
      baseScrollOption: {
        step: 0.6,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 0,
      },
      type: 3,
      dataArray: [],
      current: 0,
      pageSize: 30,
      refreshTimer: null,
    }
  },
  mounted() {
    this.initData()
    this.refreshTimer = setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer)
  },
  methods: {
    async initData() {
      const [res, err] = await to(
        customerPurchaseRank({
          type: this.type,
          size: 500,
        }),
      )
      if (err) return
      const list = res && res.data && Array.isArray(res.data.list) ? res.data.list : []
      const nextDataArray = _.chunk(list, this.pageSize)
      const maxIndex = nextDataArray.length - 1

      this.current = maxIndex >= 0 ? Math.min(this.current, maxIndex) : 0
      this.dataArray = nextDataArray
      this.syncSwiperPage()
    },
    typeChange(type) {
      this.type = type
      this.initData()
    },
    getScrollOption(dataLength) {
      return {
        ...this.baseScrollOption,
        limitMoveNum: dataLength,
      }
    },
    syncSwiperPage() {
      this.$nextTick(() => {
        const swiper = this.$refs.Swiper && this.$refs.Swiper.swiper
        if (swiper) {
          if (swiper.update) swiper.update()
          if (swiper.activeIndex !== this.current) {
            swiper.slideTo(this.current, 0)
          }
        }
      })
    },
    handleScrollEnd() {
      setTimeout(() => {
        if (!this.dataArray.length) return
        if (this.current >= this.dataArray.length - 1) {
          this.$refs.Swiper.swiper.slideTo(0)
        } else {
          this.$refs.Swiper.swiper.slideNext()
        }
      }, 1000)
    },
  },
}
</script>
<style lang="scss" scoped>
.SchoolProcurementRank {
  position: relative;
  height: 100%;
  box-sizing: border-box;

  .title {
    position: relative;
    width: 100%;
    height: 70px;
    border-radius: 7px 7px 0px 0px;
    font-weight: bold;
    font-size: 30px;
    color: #fefefe;
    line-height: 70px;
    padding-left: 47px;

    margin-bottom: 10px;
    span {
      position: relative;
      z-index: 9;
    }
    &::after {
      z-index: 8;
      content: '';
      position: absolute;
      left: 25px;
      bottom: 5px;
      width: 366px;
      height: 23px;
      background: url('~@/img/agriculture/title_line.png') 100% 100%;
    }
  }

  .tab {
    z-index: 99;
    position: absolute;
    right: 60px;
    top: 30px;
    width: 126px;
    font-size: 20px;
    text-align: center;
    animation: fadeIn 0.5s ease-out;
  }

  .swiper-button-next {
    z-index: 999;
    top: 55px;
    position: absolute;
    right: 40px;
    height: 22px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.2);
    }
  }

  .swiper-button-prev {
    z-index: 999;
    top: 55px;
    position: absolute;
    left: 450px;
    height: 22px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.2);
    }
  }

  .swiper {
    height: 470px;
  }

  .progress-list {
    box-sizing: border-box;
    padding-left: 8px;
    overflow: hidden;

    .progress-item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      line-height: 32px;
      padding: 0 16px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      cursor: pointer;
      will-change: transform;
      animation: slideInLeft 0.5s ease-out forwards;
      opacity: 0;
      position: relative;

      .index {
        width: 39px;
        height: 32px;
        border-radius: 2px 2px 2px 2px;
        font-weight: 400;
        font-size: 21px;
        color: #ffffff;
        line-height: 32px;
        text-align: center;
        background: #3d8fff;
      }

      &.item1 {
        .index {
          background: #ff3232;
        }
      }

      &.item2 {
        .index {
          background: #ff9800;
        }
      }

      &.item3 {
        .index {
          background: #ffd200;
        }
      }

      .name {
        width: 100%;
        height: 21px;
        font-size: 19px;
        color: #ffffff;
        line-height: 21px;
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes glow {
  from {
    box-shadow: 0 0 12px currentColor;
  }

  to {
    box-shadow: 0 0 20px currentColor, 0 0 30px currentColor;
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
